export * from "./classes/transition-controller";
export * from "./classes/transition";
export * from "./directives/transition";
export * from "./transition.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/transition/index.js
// module id = 30
// module chunks = 0